import { Flex } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components';
import { useResellerDetail } from 'hooks';

import { Address, Email, MessageInfo, Phone } from './components';
import Styles from './Detail.styles';

export const Detail = () => {
  const { data: detail, isLoading } = useResellerDetail();

  return (
    <Flex gap='$4' direction='column'>
      <ResponsiveFloraTypography fontSize='title' as='h2' fontWeight='bold'>
        Dados cadastrais
      </ResponsiveFloraTypography>
      <MessageInfo />
      <Styles.Wrapper justify='space-between' gap='$4' align='flex-start'>
        <Styles.InfoWrapper direction='column'>
          <Phone isLoading={isLoading} phone={detail?.reseller.phone ?? ''} />
          <Email isLoading={isLoading} email={detail?.reseller.email ?? ''} />
        </Styles.InfoWrapper>
        <Styles.InfoWrapper direction='column'>
          <Address />
        </Styles.InfoWrapper>
      </Styles.Wrapper>
    </Flex>
  );
};
